import { grey } from "@mui/material/colors";

export const headerCellStyle = { backgroundColor: grey[100], fontSize: 18 }

export const cellStyle = {
  fontSize: 18,
  verticalAlign: "top",
};

export const cellWidePaddingStyle = {
  ...cellStyle,
  py: 3
}

export const orderSummaryTableStyle = {
  productName: {
    width: "15%",
    minWidth: "150px",
  },
  originName: {
    width: "10%",
    minWidth: "100px"
  },
  size: {
    width: "12%",
    minWidth: "120px",
  },
  total: {
    width: "25%",
    minWidth: "350px"
  },
  details: {
    width: "50%",
    minWidth: "560px"
  }
}

export const tableInRowStyle = {
  "& td" : {
    px: 0,
    border : 0
  },
  "& tr:last-child": {
    "& td" : {
      pb: 0
    }
  },
  "& tr:first-child": {
    "& td" : {
      pt: 0
    }
  }
}

export const orderSummaryDetailCellStyles = {
  customerShopName: {
    width: "45%", minWidth: "260px"
  },
  unitQuantity: {
    width: "18%", minWidth: "100px" 
  },
  orderQuantity: {
    width: "15%", minWidth: "80px"
  },
  orderingUnitName: {
    width: "15%", minWidth: "80px"
  }
}
